import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../../../modules/shared/shared.module';
import { DynamicLottieEditorComponent } from './dynamic-lottie-editor.component';
import { DynamicValueControlComponent } from './dynamic-value-control.component';

/**
 * Standalone packaging for the Dynamic Lottie Changes editor so any feature
 * module can open it via MatDialog without having to redeclare the component.
 * Also exports <app-dynamic-value-control> — the per-change inline control —
 * so other forms (e.g. the project-template default-values UI) can reuse the
 * same slick controls without going through the dialog.
 *
 * Owns the (template-only) Material deps these components need — keeps the
 * host modules' imports lean.
 */
@NgModule({
    declarations: [DynamicLottieEditorComponent, DynamicValueControlComponent],
    imports: [
        CommonModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTooltipModule,
        // Provides <app-lottie-video-composed> and <dynamic-lottie> for the live preview pane.
        SharedModule,
    ],
    exports: [DynamicLottieEditorComponent, DynamicValueControlComponent],
})
export class DynamicLottieEditorModule {}
